<template>
  <div class="container sv061">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>au PAY スマートローン アプリに関するアプリケーション・プライバシーポリシー</HeadingOne>

    <p class="txt01 _mb-md-50 _mb-sm-40">
      本アプリケーション（以下、本アプリ）・プライバシーポリシー（以下、プラポリ）は、auフィナンシャルサービス株式会社（以下、当社）が提供するスマートフォン向けアプリ“au
      PAY
      スマートローンアプリ”から送信されるお客さま情報とその取り扱いについて説明するものです。本アプリプラポリの内容をご確認・ご理解したうえで“au
      PAY スマートローンアプリ”をご利用ください。
    </p>

    <!-- アプリ本体の説明 -->
    <HeadingTwo>アプリ本体の説明</HeadingTwo>

    <section class="_mb-md-60 _mb-sm-40">
      <HeadingThree>アプリ本体から送信されるお客さま情報、目的、送信先</HeadingThree>
      <ListGroup class="-normal -decimal">
        <ListItem class="-normal">
          <b>au IDおよびau IDに紐付くお客さま情報</b><br />
          本アプリ上で、ご入力頂いたau
          IDおよびau IDに紐付くお客さま情報は、当社およびKDDI株式会社へ送信され、本アプリの機能の提供及び運営、マーケティング分析、その他当社のサービスの品質向上及び訴求のために利用されます。
        </ListItem>
        <ListItem class="-normal">
          <b>お客さまを認証するクッキー情報</b><br />
          本アプリ上で、お客さまがログインを実行した際に取得したお客さまを認証するクッキー情報を、お客さま毎の情報提供・サービス分析のために、KDDI株式会社へ送信します。
        </ListItem>
        <ListItem class="-normal">
          <b>アクセスデータ</b><br />
          本アプリは、アプリ・サービスの利用状況解析およびその利用状況解析を元にした広告効果の検証・改善及び最適な広告の配信のため、お客さまが閲覧した画面のページビュー数、インプレッション数、クリック数並びに利用者による閲覧履歴及びクリック等の操作履歴（以下「アクセスデータ」）を取得する機能を有しています。
        </ListItem>
      </ListGroup>
      <p class="txt01">
        当社は、これらの情報を法令等で定められている場合を除き、あらかじめお客さまの同意を得ることなく第三者に提供することはありません。
      </p>
    </section>

    <section class="_mb-md-60 _mb-sm-40">
      <HeadingThree>アプリ本体から送信されるお客さま情報の送信停止／削除とその影響など</HeadingThree>
      <ListGroup class="-normal">
        <ListItem class="-normal">
          本アプリは、お客さま情報の送信を停止する手段を提供しておりません。送信を停止したい場合には、本アプリをアンインストールしてください。
        </ListItem>
        <ListItem class="-normal">
          本アプリは、送信されたお客さま情報を送信先のサーバから削除する手段を提供しておりません。詳しくは、下記お問い合わせからご確認下さい。
        </ListItem>
      </ListGroup>
    </section>

    <!-- 組み込まれた外部の情報収集モジュールの説明 -->
    <HeadingTwo>組み込まれた外部の情報収集モジュール(※１)の説明</HeadingTwo>

    <section class="_mb-md-40 _mb-sm-30">
      <HeadingThree>情報収集モジュールから送信されるお客さま情報、目的、送信先</HeadingThree>
      <p class="txt01 _mb-md-40 _mb-sm-30">
        au PAY スマートローンアプリには、以下の情報収集モジュールが含まれます。
      </p>
      <ListGroup class="-normal">
        <ListItem class="-normal">
          <b>Googleアナリティクス</b><br />
          本アプリは、Google
          Inc.（以下「Google」）が提供する解析サービスであるGoogleアナリティクスを用いて、お客さまが閲覧した画面のページビュー数、インプレッション数、クリック数（以下「数値情報」）を取得する機能を有しています。なお、数値情報は、分析統計処理が施され、個人が特定できないように加工されています。<br />
          当社は、数値情報を取得し、マーケティング分析及び当社のサービス（本アプリの提供に限りません。）の品質向上のため利用します。また、Googleは、Googleの責任の下、Googleの利用規約及びプライバシーポリシーに基づき、数値情報を管理します。詳細については、Googleのホームページでご確認ください。
          <p class="link-line">
            <OutLink href="http://www.google.co.jp/intl/ja/policies/privacy/"
              >Googleのプライバシーポリシー</OutLink
            >
          </p>
        </ListItem>
      </ListGroup>

      <ListGroup class="-note">
        <ListItem class="-note">
          １:情報収集モジュールとは、広告表示やアプリの利用頻度を解析する、アプリ本体の機能とは独立した、第三者が作成したプログラムのことです。
        </ListItem>
      </ListGroup>
    </section>

    <!-- アプリ／アプリ提供者の説明 -->
    <HeadingTwo>アプリ／アプリ提供者の説明</HeadingTwo>

    <section class="_mb-md-40 _mb-sm-30">
      <HeadingThree>当社の個人情報保護方針</HeadingThree>
      <p class="txt01">
        当社の個人情報保護方針は、下記のリンクよりご確認ください。当社個人情報保護方針と、本アプリプラポリが異なる場合には、本アプリプラポリが優先されるものとします。
      </p>
      <p class="link-line">
        <OutLink href="https://www.aufs.co.jp/company/policy/privacy.html"
          >auフィナンシャルサービスの企業ポリシー</OutLink
        >
      </p>
    </section>

    <section class="_mb-md-40 _mb-sm-30">
      <HeadingThree>当社お客さま情報の取り扱いに関するお問い合わせ、ご相談は以下の窓口でお受けいたします。</HeadingThree>
      <p class="txt01">au PAY スマートローン お問い合わせ</p>
      <p class="link-line">
        <OutLink href="https://loan.kddi-fs.com/inquiry/"
          >https://loan.kddi-fs.com/inquiry/</OutLink
        >
      </p>
    </section>

    <section class="_mb-md-40 _mb-sm-30">
      <HeadingThree>本アプリプラポリの変更について</HeadingThree>
      <p class="txt01">
        本アプリのバージョンアップに伴って、送信されるお客さま情報、目的、送信先が変更される場合があります。変更内容などは、新バージョンのアプリに付随するアプリプラポリをご参照ください。
      </p>
    </section>

    <p class="txt01 -right">以上</p>
  </div>
  <!-- container -->
</template>

<script>
import { isWebView } from "@/utils/UserAgent";
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import HeadingThree from "@/components/heading/HeadingThree";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import OutLink from "@/components/link/OutLink";

export default {
  name: "Sv061",
  components: {
    BreadcrumbGroup,
    HeadingOne,
    HeadingTwo,
    HeadingThree,
    ListGroup,
    ListItem,
    OutLink,
  },
  setup() {
    setMeta({
      title: "au PAY スマートローン アプリに関するアプリケーション・プライバシーポリシー",
      description: "",
      keywords: "",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "au PAY スマートローン アプリに関するアプリケーション・プライバシーポリシー",
          active: true,
        },
      ],
    };
  },
  mounted() {
    setTimeout(this.scrolleToHash, 300);
  },
  methods: {
    scrolleToHash() {
      if (this.$route.hash.match(/^#/)) {
        let id = this.$route.hash.replace(/^#/, "");
        let element = document.getElementById(id);
        let height = window.matchMedia && window.matchMedia("(max-device-width: 767px)").matches ? -70 : -120;
        let offset = isWebView() ? -10 : height;
        this.$scrollTo(element, 400, { easing: "ease", offset: offset });
      }
    },
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.sv061 {
  .txt01 {
    font-size: 14px;
    line-height: 22px;
    @include mq-up(md) {
      font-size: 16px;
      line-height: 26px;
    }
    &.-right {
      text-align: right;
    }
    &.-center {
      text-align: center;
    }
  }

  :deep(.list-group) {
    &.-decimal {
      .list-item {
        list-style-type: decimal;
      }
    }
  }

  .link-line {
    margin-top: 8px;
    word-break: break-all;
    font-size: 14px;
    line-height: 22px;
    @include mq-up(md) {
      font-size: 16px;
      line-height: 26px;
    }
  }
}
</style>
